import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRICE_PREVIEW } from "@/data/site";
import { Reveal } from "@/lib/motion";
import { AddToEnquiryButton, slugify } from "@/components/site/AddToEnquiryButton";

export const PricingPreview = () => {
  return (
    <section id="pricing" data-testid="pricing-preview" className="relative z-10 overflow-hidden bg-[#0B0D11] py-24 sm:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_15%,rgba(23,147,255,0.16),transparent_45%)]" />
      <div className="container-x relative">
        <Reveal className="mb-12 max-w-2xl">
          <span className="eyebrow mb-4"><span className="h-px w-8 bg-[var(--blue-bright)]" /> Pricing Preview</span>
          <h2 className="font-display text-4xl font-800 leading-tight tracking-tight text-white sm:text-5xl">
            Clear pricing, no surprises.
          </h2>
          <p className="mt-4 text-base text-[var(--muted)]">
            A quick look at popular prices — the full breakdown lives on our Services &amp; Pricing page.
          </p>
        </Reveal>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {PRICE_PREVIEW.map((p, i) => (
            <motion.div key={p.label}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
              className="card-line rounded-xl px-6 py-5 transition-colors duration-300 hover:border-[var(--blue)]/50">
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-medium text-[var(--white)]/90">{p.label}</span>
                <span className="font-display text-lg font-800 text-[var(--blue-bright)]">{p.price}</span>
              </div>
              <div className="mt-3">
                <AddToEnquiryButton id={`preview-${slugify(p.label)}`} name={p.label} price={p.price} compact />
              </div>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <Link to="/services" data-testid="pricing-view-full" className="btn-electric">
            View Full Pricing <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
